import RedeemIcon from '@mui/icons-material/Redeem';
import IconButton from '@mui/material/IconButton';
import Box from '@mui/material/Box';
import { withRouter } from 'react-router';
import React from 'react';
import './UserMissions.scss';
import { getIsChubbUser } from '../../utils/user';

const MissionAndRewardEntryButton = withRouter(({ history }) => {
  //   {/* <img
  //   src={'/img/mission-and-reward/trophy.png'}
  //   style={{
  //     color: '#3966f8',
  //    }}
  //   alt="throphy" width={20} height={20} /> */}
  //   <RedeemIcon style={{ color: '#efefef', fontSize: '24px' }} />
  // </Button>

  const isUserMissionPage = history.location.pathname === '/new/user-mission';
  const isChubbUserMissionPage = history.location.pathname === '/new/chubb-user-mission';
  const isHomePage = history.location.pathname === '/home';
  if (isUserMissionPage || isChubbUserMissionPage || !isHomePage) {
    return null;
  }
  const isChubbUser = getIsChubbUser();
  return (
    // <Button onClick={() => {
    //   history.push('/new/user-mission');
    // }}
    <Box
      style={{
        borderRadius: '100%',
        position: 'fixed',
        minHeight: 'fit-content',
        minWidth: 'fit-content',
        left: '40px',
        zIndex: 1200,
        backgroundColor: 'transparent'
      }}
    >
      <IconButton
        className="user-missions-button squeezed-button shake-once"
        onClick={() => {
          if (isChubbUser) {
            history.push('/new/chubb-user-mission');
          } else {
            history.push('/new/user-mission');
          }
        }}
        size="large">
        <img src="img/mission-and-reward/trophy.svg" alt="user-mission" width={20} height={20} />
      </IconButton>
    </Box>
  );
});

export default MissionAndRewardEntryButton;
